import { createSelector } from 'reselect';

const getPopup = (state: import('../types/rootState').RootState): import('../types/popup').Popup =>
  state.popup;

const getWishlistState = createSelector(getPopup, ({ showWislistPopup, wishlistStatus }) => ({
  showWislistPopup,
  wishlistStatus
}));

const getAddToCartState = createSelector(getPopup, ({ showCartPopup, addedToCart }) => ({
  showCartPopup,
  addedToCart
}));

const getAddToCartStateForMembership = createSelector(
  getPopup,
  ({ addedToCartMembership }) => addedToCartMembership
);

export { getWishlistState, getAddToCartState, getAddToCartStateForMembership };
